var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortBoth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.711 8.88253L12.1861 6.29253C11.8059 5.90253 11.1917 5.90253 10.8115 6.29253L8.28662 8.88253C7.67246 9.51253 8.11115 10.5925 8.97878 10.5925L14.0286 10.5925C14.8962 10.5925 15.3251 9.51253 14.711 8.88253Z",
    fill: "#2E2E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28902 14.71L10.8139 17.3C11.1941 17.69 11.8083 17.69 12.1885 17.3L14.7134 14.71C15.3275 14.08 14.8889 13 14.0212 13H8.97143C8.1038 13 7.67486 14.08 8.28902 14.71Z",
    fill: "#2E2E3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBoth);
export default __webpack_public_path__ + "static/media/sortBoth.95ef1908d7124e6b5b15da6a06fd7eff.svg";
export { ForwardRef as ReactComponent };